import classcat from "classcat";
import Markdown from "markdown-to-jsx";
import React from "react";

import { Checkbox } from "@touchtech/baselayer-ui";
import { Label } from "@touchtech/web-baselayer-ui";

import { Agreement } from "@is/types";

import css from "./AgreementItem.module.css";
import useManageAgreementItem from "./hooks/useManageAgreementItem";

type Props = {
  agreement: Agreement;
  onOpenExternalPage: (src: string) => void;
  onToggleCheckbox: (id: string) => void;
  showPaymentErrorMessage: boolean;
};

const AgreementItem = ({
  agreement,
  onOpenExternalPage,
  onToggleCheckbox,
  showPaymentErrorMessage,
}: Props) => {
  const { handleToggle, handleClick, translation } = useManageAgreementItem({
    agreement,
    onToggleCheckbox,
    onOpenExternalPage,
  });

  return (
    <>
      {!!translation && (
        <div className={css.container}>
          <div
            className={classcat([
              css.checkboxWrapper,
              { [css.checked]: agreement.isChecked },
            ])}
          >
            <Checkbox
              size="medium"
              checked={agreement.isChecked}
              className={classcat({
                [css.checkboxError]:
                  agreement.isRequired && showPaymentErrorMessage,
              })}
              onChange={handleToggle}
            />
          </div>
          <Label>
            <Markdown
              options={{
                overrides: {
                  a: {
                    props: {
                      onClick: handleClick,
                      className: css.hyperlink,
                    },
                  },
                },
              }}
            >
              {translation}
            </Markdown>
          </Label>
        </div>
      )}
    </>
  );
};

export default AgreementItem;
